let lessonsCreateFilters = {
  showItems: false,
  searchFilters: {
    search_query: null,
    classifiers: [],
    types: {},
  },
  activeFilters: {
    search_query: '',
    types: {},
    classifiers: {},
  },
  statusComplect: 0,
};

const getters = {
  GET_CLASSIFIERS(state) {
    return state.searchFilters.classifiers;
  },
  GET_SEARCH_QUERY(state) {
    return state.searchFilters.search_query;
  },
  GET_TYPES(state) {
    return state.searchFilters.types;
  },
  GET_ACTIVE_FILTERS(state) {
    return state.activeFilters;
  },
  GET_SHOW_ITEMS(state) {
    return state.showItems;
  },
  GET_STATUS_COMPLECT(state) {
    return state.statusComplect;
  },
};
const mutations = {
  RESET_SEARCH(state) {
    state.showItems = false;
    state.searchFilters.search_query = '';
    state.searchFilters.classifiers = [];
    state.searchFilters.types = {};
    state.activeFilters = {
      types: {},
      classifiers: {},
    };
    state.statusComplect = 0;
  },
  SET_SEARCH_FILTERS(state, data) {
    state.showItems = true;
    state.searchFilters = {
      search_query: data.search_query,
      classifiers: data.classifiers,
      types: data.types,
    };
  },
  ADD_CLASSIFIERS(state, data) {
    state.searchFilters.classifiers = data;
  },
  ADD_SEARCH_QUERY(state, data) {
    state.searchFilters.search_query = data;
  },
  SET_ACTIVE_FILTERS(state, data) {
    state.activeFilters = data;
  },
  SET_STATUS_COMPLECT(state, data) {
    state.statusComplect = data;
  },
};

const actions = {
  setSearchFilters({ commit }, data) {
    commit("SET_SEARCH_FILTERS", data);
  },
  hideItems({ commit }) {
    commit("HIDE_ITEMS");
  },
  resetSearch({ commit }) {
    commit("RESET_SEARCH");
  },
  addClassifiers({ commit }, data) {
    commit("ADD_CLASSIFIERS", data)
  },
  addSearchQuery({ commit }, data) {
    commit("ADD_SEARCH_QUERY", data)
  },
  setActiveFilters({ commit }, data) {
    commit('SET_ACTIVE_FILTERS', data);
  },
  setStatusComplect({ commit }, data) {
    commit('SET_STATUS_COMPLECT', data);
  },
};

export default {
  namespaced: true,
  state: lessonsCreateFilters,
  getters,
  mutations,
  actions,
};
